module.exports = __webpack_public_path__ + "assets/img/smartTV-module5-1.305356f5.jpg";